import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vfmPlugin from 'vue-final-modal'
import Toaster from '@meforma/vue-toaster';
import VueObserveVisibility from 'vue-observe-visibility'

createApp(App).use(store).use(router).use(vfmPlugin).use(Toaster).use(VueObserveVisibility).mount('#app');
